var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgAccountTreeOutlined = function SvgAccountTreeOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    "aria-hidden": "true",
    width: "1em",
    height: "1em",
    style: {
      msTransform: "rotate(360deg)",
      WebkitTransform: "rotate(360deg)"
    },
    viewBox: "0 0 24 24",
    transform: "rotate(360)",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3h7zM7 9H4V5h3v4zm10 6h3v4h-3v-4zm0-10h3v4h-3V5z"
  })));
};
export default SvgAccountTreeOutlined;